import { render, staticRenderFns } from "./OutNews.vue?vue&type=template&id=02f36a74&scoped=true&"
import script from "./OutNews.vue?vue&type=script&lang=js&"
export * from "./OutNews.vue?vue&type=script&lang=js&"
import style0 from "./OutNews.vue?vue&type=style&index=0&id=02f36a74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f36a74",
  null
  
)

component.options.__file = "OutNews.vue"
export default component.exports